import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EfficientListLoader } from "@faire/retailer-visitor-shared/components/EfficientListLoader/EfficientListLoader";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { ProductTileImpressionProvider } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/__internal__/ProductTileImpressionProvider";
import { getFirstVideo } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/CollectionDiscovery/utils";
import { CollectionVideoTile } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/CollectionVideoTile";
import { ProductBasedCollectionItem } from "@faire/retailer-visitor-shared/views/product-based-collection/__internal__/ProductBasedCollectionItem";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { Grid } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { trackApparelCollectionsVideoFailedToPlay } from "@faire/web-api--source/events/apparelCollections/actionUnknown/videoFailedToPlay";
import React from "react";
import styled from "styled-components";
export var PBCEfficientBuyingItemList = function(param) {
    var productTiles = param.productTiles, collection = param.collection, _param_showVerticalImagery = param.showVerticalImagery, showVerticalImagery = _param_showVerticalImagery === void 0 ? false : _param_showVerticalImagery, columnCount = param.columnCount, gridGap = param.gridGap, collectionPromo = param.collectionPromo;
    var video = getFirstVideo(collection.videos);
    var retailerToken = useRetailer().retailerToken;
    var renderProductItem = function(item) {
        var _item_product;
        return /*#__PURE__*/ _jsx(ProductBasedCollectionItem, {
            collection: collection,
            productTile: item,
            showVerticalImagery: showVerticalImagery,
            collectionPromo: collectionPromo
        }, (_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product.token);
    };
    return /*#__PURE__*/ _jsxs(StyledGrid, {
        rowGap: 24,
        columnGap: gridGap,
        columns: columnCount,
        columnTemplate: function(columns) {
            return "repeat(".concat(columns, ", minmax(0, 232px));");
        },
        children: [
            /*#__PURE__*/ _jsx(ProductTileImpressionProvider, {
                productBasedCollectionToken: collection.token,
                requestId: collection.request_id,
                children: /*#__PURE__*/ _jsx(EfficientListLoader, {
                    data: productTiles,
                    renderComponent: renderProductItem,
                    batchSize: columnCount * 2,
                    forceRender: isPrerender(),
                    filterFakeTile: true,
                    threshold: -500,
                    hashKey: collection.token
                })
            }),
            video ? /*#__PURE__*/ _jsx(CollectionVideoTile, {
                columnCount: columnCount,
                tileCount: productTiles.length,
                video: video,
                onFailedToPlayVideo: function() {
                    var _collection_token, _video_token;
                    return trackApparelCollectionsVideoFailedToPlay(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", (_collection_token = collection === null || collection === void 0 ? void 0 : collection.token) !== null && _collection_token !== void 0 ? _collection_token : "", (_video_token = video === null || video === void 0 ? void 0 : video.token) !== null && _video_token !== void 0 ? _video_token : "");
                }
            }) : null
        ]
    });
};
var StyledGrid = styled(Grid).withConfig({
    componentId: "sc-bdd4faf1-0"
})([
    "",
    "{grid-auto-rows:1fr;}overflow:visible;"
], responsiveMediaQueries.tabletAndAbove);
